import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { madrs } from 'neuro-schemas';
import { isNumber, isPartialDate } from 'neuro-utils';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType } from 'Utility/documentHandling';
import { sortDocuments } from 'Utility/randomUtil';

const { calculateScore } = madrs;

const InterviewSurveysDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const sortedDocs = filterDocumentsByType(documents, ['gaf', 'madrs']).sort((a, b) =>
    sortDocuments([{ type: 'date', sortField: 'date' }])(a, b),
  );

  const { formatMessage } = useIntl();

  return (
    <TileContentMaker
      type="recentList"
      data={sortedDocs.map(d => ({
        date: isPartialDate(d.date) ? formatPartialDate(d.date) : '',
        title: formatMessage({ id: `interviewSurveys.${d._type}.title` }),
        value: d._type === 'madrs' ? `${isNumber(calculateScore(d)) ? calculateScore(d) : ''}` : `${d.gafValue}`,
        key: d._id,
      }))}
    />
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'madrs' | 'gaf'>>;
}

export default InterviewSurveysDash;
